// extracted by mini-css-extract-plugin
export default {"addCardModal":"AddCard_addCardModal__91gme","closeModal":"AddCard_closeModal__ECeBd","header":"AddCard_header__2kVXV"};